import { FilterPopover } from 'components/filter';

import TaxDetailsFilter from './tax-details-filter';

export const TaxDetailsFilterButton = () => {
  return <FilterPopover content={TaxDetailsFilter}></FilterPopover>;
};
